import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { UserAnnotationsEffects } from './user-annotations.effects';
import { userAnnotationsReducer } from './user-annotations.reducer';
import { UserAnnotationsService } from './user-annotations.service';
import {
  STATE_USER_ANNOTATIONS,
  getInitialUserAnnotationsState,
} from './user-annotations.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([UserAnnotationsEffects]),
    StoreModule.forFeature(STATE_USER_ANNOTATIONS, userAnnotationsReducer, {
      initialState: getInitialUserAnnotationsState,
    }),
    TarlV3JsonapiModule,
  ],
  providers: [UserAnnotationsService],
})
export class UserAnnotationsModule {}
